export default "__VITE_ASSET__Dlxs62mk__"